<div class="item">
  <div>{{ message().timeStamp | date: 'yyyy-MM-dd HH:mm' }}</div>
  <a mat-button [routerLink]="['/', 'home', message().messageId]">
    {{ message().senderName }}
  </a>
  @if (message().messageRead) {
    <mat-icon>drafts</mat-icon>
  } @else {
    <mat-icon>mail</mat-icon>
  }
</div>
<mat-divider></mat-divider>